module.exports = __webpack_public_path__ + "img/warning.2200ff01.svg";